document.addEventListener("DOMContentLoaded", async function () {
  let loadingInterval;
  let smileRef = null; // Captured reference to the Smile SDK

  function startLoadingAnimation(element) {
    let dots = 0;
    loadingInterval = setInterval(() => {
      dots = (dots + 1) % 4;
      element.textContent = ".".repeat(dots || 1);
    }, 500);
  }

  function stopLoadingAnimation() {
    clearInterval(loadingInterval);
  }
  // Start loading animation immediately
  const pointsDiv = document.getElementById("points-balance");
  if (pointsDiv) {
    startLoadingAnimation(pointsDiv);
  }

  // Tab switching
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tabName = button.dataset.tab;

      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      button.classList.add("active");
      const tabContent = document.getElementById(`${tabName}-content`);
      if (tabContent) tabContent.classList.add("active");
    });
  });

  // Smile and JWT:
  // Smile docs reference for this file:
  // - JS purchase API: https://dev.smile.io/js/resources/points-products/purchase
  // - JS points purchase object: https://dev.smile.io/js/resources/points-purchases/object
  // - JS error handling + ApiError: https://dev.smile.io/js/concepts/error-handling
  // - REST points purchase object (snake_case fields):
  //   https://dev.smile.io/api/resources/points-purchases/points-purchase-object
  let isLoggedIn = false;

  async function initializeSmileUI(maxAttempts = 30, interval = 1000) {
    const customerInfoElement = document.getElementById("customerInfo");
    const customerId = customerInfoElement
      ? customerInfoElement.dataset.customerId
      : null;

    let jwt = null;
    if (customerId) {
      try {
        const response = await fetch(
          `https://d7fjx84350.execute-api.us-east-2.amazonaws.com/prod/?customerId=${encodeURIComponent(customerId)}`,
        );
        if (!response.ok) {
          throw new Error(`Token request failed: ${response.status}`);
        }
        const data = await response.json();
        jwt = data.customerToken || data.jwt || null;
      } catch (e) {
        console.warn("DEBUG: Failed to fetch JWT:", e);
      }
    }

    for (let attempts = 0; attempts < maxAttempts; attempts++) {
      if (typeof SmileUI !== "undefined" && SmileUI) {
        // Check if initialize is a function before calling it
        if (typeof SmileUI.initialize === "function") {
          const initOptions = {
            publishableKey: "pub_9d3c329fe120ace1",
            includeSdk: true,
          };
          if (jwt) {
            initOptions.customerToken = jwt;
            isLoggedIn = true;
          }
          try {
            SmileUI.initialize(initOptions);
            return "SmileUI initialized successfully";
          } catch (initError) {
            console.error(
              "DEBUG: SmileUI.initialize() threw an error:",
              initError,
            );
            throw new Error(
              `SmileUI.initialize() failed: ${initError.message}`,
            );
          }
        }
      }
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
    throw new Error(`SmileUI not available after ${maxAttempts} attempts`);
  }

  try {
    await initializeSmileUI();
  } catch (error) {
    console.error("Failed to initialize SmileUI");
    if (pointsDiv) {
      stopLoadingAnimation();
      pointsDiv.textContent = "--";
    }
    return;
  }

  // Helper: resolve the Smile SDK reference (with retry)
  async function getSmile(maxAttempts = 60, interval = 500) {
    if (smileRef) return smileRef;

    function hasRequiredRewardsMethods(smileCandidate) {
      return Boolean(
        smileCandidate?.pointsProducts?.get &&
        smileCandidate?.pointsProducts?.purchase &&
        smileCandidate?.customer?.current &&
        smileCandidate?.customerVipStatus?.get &&
        smileCandidate?.customerPointsWallet?.get,
      );
    }

    for (let i = 0; i < maxAttempts; i++) {
      // Prefer SmileUI-owned SDK instance to avoid proxy/version mismatch.
      if (typeof SmileUI !== "undefined" && SmileUI) {
        if (SmileUI.smile && hasRequiredRewardsMethods(SmileUI.smile)) {
          smileRef = SmileUI.smile;
          return smileRef;
        }
      }
      if (
        typeof Smile !== "undefined" &&
        Smile &&
        hasRequiredRewardsMethods(Smile)
      ) {
        smileRef = Smile;
        return smileRef;
      }
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
    throw new Error(
      "Smile SDK is not available yet. Ensure SmileUI.initialize() is called with includeSdk: true.",
    );
  }

  async function fetchPointsProducts() {
    const smile = await getSmile();

    const pointsProducts = await smile.pointsProducts.get();
    const discountContent = document.querySelector("#discount-content");
    const productContent = document.querySelector("#product-content");

    // Remove skeleton loading cards
    document.querySelectorAll(".skeleton-card").forEach((el) => el.remove());

    // Create a map of pointsProducts for easy lookup
    const pointsProductMap = new Map(
      pointsProducts
        .filter((product) => getRewardName(product))
        .map((product) => [normalizeRewardName(getRewardName(product)), product]),
    );

    // Keep track of products we've already displayed
    const displayedProducts = new Set();

    // Iterate through discountButtonsData in the order defined in Liquid
    if (typeof discountButtonsData !== "undefined" && discountButtonsData) {
      discountButtonsData.forEach(({ imageUrl, productUrl }, productName) => {
        const pointsProduct = pointsProductMap.get(
          normalizeRewardName(productName),
        );
        if (pointsProduct) {
          const discountBtn = createDiscountButton(
            pointsProduct,
            imageUrl,
            productUrl,
          );
          const targetContent = isCouponReward(pointsProduct)
            ? discountContent
            : productContent;
          const wrapper = targetContent
            ? targetContent.querySelector(".flex-content-wrapper")
            : null;
          if (wrapper) wrapper.appendChild(discountBtn);
          displayedProducts.add(pointsProduct.id);
        }
      });
    }

    // Display any remaining products that weren't in discountButtonsData
    pointsProducts.forEach((pointsProduct) => {
      if (!displayedProducts.has(pointsProduct.id)) {
        const discountBtn = createDiscountButton(pointsProduct);
        const targetContent = isCouponReward(pointsProduct)
          ? discountContent
          : productContent;
        const wrapper = targetContent
          ? targetContent.querySelector(".flex-content-wrapper")
          : null;
        if (wrapper) wrapper.appendChild(discountBtn);
      }
    });

    await setupCustomerAndButtons();
  }

  function createDiscountButton(pointsProduct, imageUrl, productUrl) {
    const discountBtn = document.createElement("button");
    const rewardName = getRewardName(pointsProduct);
    const rewardDescription = getRewardDescription(pointsProduct);
    discountBtn.className = "discount-btn content-block";
    discountBtn.dataset.pointsProductId = pointsProduct.id;
    discountBtn.dataset.title = rewardName;
    discountBtn.dataset.productUrl = productUrl || "";

    const couponAssets = document.getElementById("coupon-assets");
    const couponUrls = couponAssets
      ? {
          5: couponAssets.dataset.coupon5,
          10: couponAssets.dataset.coupon10,
          15: couponAssets.dataset.coupon15,
          20: couponAssets.dataset.coupon20,
          50: couponAssets.dataset.coupon50,
          couponProduct: couponAssets.dataset.couponProduct,
        }
      : {};
    const couponPopupUrls = couponAssets
      ? {
          5: couponAssets.dataset.coupon5Popup,
          10: couponAssets.dataset.coupon10Popup,
          15: couponAssets.dataset.coupon15Popup,
          20: couponAssets.dataset.coupon20Popup,
          50: couponAssets.dataset.coupon50Popup,
          couponProduct: couponAssets.dataset.couponProductPopup,
        }
      : {};

    function getCouponImg(discount) {
      const discountNumber = parseInt(discount, 10);
      if ([5, 10, 15, 20, 50].includes(discountNumber)) {
        return couponUrls[discountNumber];
      }
      return couponUrls.couponProduct;
    }
    function getCouponPopupImg(discount) {
      const discountNumber = parseInt(discount, 10);
      if ([5, 10, 15, 20, 50].includes(discountNumber)) {
        return couponPopupUrls[discountNumber];
      }
      return couponPopupUrls.couponProduct;
    }

    const pointsRequired = getPointsRequired(pointsProduct);

    if (isCouponReward(pointsProduct)) {
      const discountAmount = extractDiscountAmount(rewardName);
      discountBtn.innerHTML = `
        <img src="${getCouponImg(discountAmount)}" 
        alt="${rewardName} Coupon"
        width="258"
        height="311"
        class="normal-version"
        >
        <img src="${getCouponPopupImg(discountAmount)}" 
        alt="${rewardName} Coupon"
        width="258"
        height="311"
        class="popup-version"
        >
        <div class="discount-bottom-absolute">
          <div class="discount-code-title">Discount code</div>
          <div class="discount-code-desc">${rewardDescription}</div>
          <div class="discount-credits" style="margin-bottom: 16px;">${pointsRequired} Points</div>
          <div class="membership-banner-btn membership-banner-btn--outline membership-banner-btn--black"
          style="max-width: 148px; font-size: 14px; margin-top: 20px;"
          >Redeem Now</div>
        </div>
      `;
    } else {
      const productImageUrl = imageUrl || null;
      discountBtn.innerHTML = `
        <img src="${getCouponImg("product")}" alt="${
          rewardName
        } Coupon"
        width="260"
        height="410"
        class="normal-version"
        >
        <img src="${getCouponPopupImg("product")}" alt="${
          rewardName
        } Coupon"
        width="260"
        height="410"
        class="popup-version"
        >
        ${
          productImageUrl
            ? `
          <img 
            src="${productImageUrl}" 
            alt="${rewardName} Product" 
            class="discount-btn__product-img"
            width="263"
            height="182"
            style="position: absolute; top: 0px; left: 0px; width: 100%; height: auto; object-fit: contain; aspect-ratio: 263 / 182;"
          >
          `
            : ""
        }
        <div class="discount-bottom-absolute">
          <div class="discount-code-title discount-code-title--product">
            ${rewardName}
          </div>
          <div class="discount-code-desc">${rewardDescription}</div>
          <div class="discount-credits">${pointsRequired} Points</div>
          <div class="membership-banner-btn membership-banner-btn--outline membership-banner-btn--black"
          style="max-width: 148px; font-size: 14px; margin-top: 20px;"
          >Redeem Now</div>
        </div>
      `;
    }

    return discountBtn;
  }

  function getRewardName(pointsProduct) {
    return (
      pointsProduct?.reward?.name ||
      pointsProduct?.reward_name ||
      pointsProduct?.name ||
      "Reward"
    );
  }

  function normalizeRewardName(name) {
    return name.trim().replace(/\s+/g, " ").toLowerCase();
  }

  function getRewardDescription(pointsProduct) {
    return pointsProduct?.reward?.description || pointsProduct?.description || "";
  }

  function isCouponReward(pointsProduct) {
    return normalizeRewardName(getRewardName(pointsProduct)).endsWith(
      "off coupon",
    );
  }

  function extractDiscountAmount(couponString) {
    const match = couponString.match(/\$(\d+)/);
    return match ? match[1] : null;
  }

  function getPointsRequired(pointsProduct) {
    if (typeof pointsProduct?.pointsPrice === "number") {
      return pointsProduct.pointsPrice;
    }
    if (typeof pointsProduct?.points_price === "number") {
      return pointsProduct.points_price;
    }
    const exchangeDescription =
      pointsProduct?.exchangeDescription || pointsProduct?.exchange_description || "";
    const match = exchangeDescription.match(/(\d+)/);
    return match ? Number(match[1]) : 0;
  }

  function extractRewardCode(pointsPurchase) {
    // Accept both JS SDK camelCase and REST snake_case shapes.
    const normalizedPurchase =
      pointsPurchase?.points_purchase || pointsPurchase;

    return (
      normalizedPurchase?.reward_fulfillment?.code ||
      normalizedPurchase?.reward_fulfillment?.discount_code ||
      normalizedPurchase?.rewardFulfillment?.code ||
      normalizedPurchase?.rewardFulfillment?.discountCode ||
      normalizedPurchase?.rewardCode ||
      normalizedPurchase?.code ||
      null
    );
  }

  function looksLikeSuccessfulPurchase(pointsPurchase) {
    // Accept both JS SDK camelCase and REST snake_case shapes.
    const normalizedPurchase =
      pointsPurchase?.points_purchase || pointsPurchase;

    return Boolean(
      normalizedPurchase &&
      !normalizedPurchase.error &&
      !normalizedPurchase.errors &&
      (normalizedPurchase.id ||
        typeof normalizedPurchase.pointsSpent === "number" ||
        typeof normalizedPurchase.points_spent === "number" ||
        normalizedPurchase.reward_fulfillment ||
        normalizedPurchase.rewardFulfillment ||
        normalizedPurchase.transaction ||
        normalizedPurchase.points_transaction),
    );
  }

  function getErrorStatus(err) {
    // Smile ApiError exposes `status`; some wrappers nest it under `response.status`.
    if (err && typeof err.status === "number") return err.status;
    if (err?.response && typeof err.response.status === "number") {
      return err.response.status;
    }
    return null;
  }

  // Set up userRef links immediately
  setupUserRefLinks();

  function clickToOpenLoginPopup(event) {
    event.preventDefault();
    showLoginPopup();
  }

  function setupUserRefLinks() {
    const userRefLinks = document.querySelectorAll(".user-ref-link");
    userRefLinks.forEach((userRefLink) => {
      userRefLink.style.cursor = "pointer";
      userRefLink.addEventListener("click", clickToOpenLoginPopup);
    });
  }

  async function setupCustomerAndButtons() {
    // If not logged in, skip customer fetch and set up login popups directly
    if (!isLoggedIn) {
      const discountButtons = document.querySelectorAll(".discount-btn");
      const userRefLinks = document.querySelectorAll(".user-ref-link");

      [...discountButtons, ...userRefLinks].forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          showLoginPopup();
        });
      });

      if (pointsDiv) {
        stopLoadingAnimation();
        pointsDiv.textContent = "--";
      }
      return;
    }

    try {
      const smile = await getSmile();
      const customer = await smile.customer.current();
      const vipStatus = await smile.customerVipStatus.get();

      // VIP tiers
      const tierName = (
        vipStatus?.vipTier?.name ||
        vipStatus?.tier?.name ||
        ""
      ).toLowerCase();
      const vipTierElements = document.querySelectorAll("[data-vip-tier]");
      vipTierElements.forEach((element) => {
        if (element.dataset.vipTier == tierName) {
          const badge = element.querySelector(".vip-tier-badge");
          if (badge) badge.textContent = "Current status";
        }
      });

      // Referral link
      const userRefLinks = document.querySelectorAll(".user-ref-link");
      userRefLinks.forEach((userRefLink) => {
        userRefLink.style.cursor = "pointer";
        userRefLink.removeEventListener("click", clickToOpenLoginPopup);
        userRefLink.addEventListener("click", (event) => {
          event.preventDefault();
          const referralUrl = customer?.referralUrl || customer?.referral_url;
          if (!referralUrl) return;
          navigator.clipboard.writeText(referralUrl);
          showCopySuccessPopup();
        });
      });

      // Points balance
      if (pointsDiv) {
        stopLoadingAnimation();
        const pointsWallet = await smile.customerPointsWallet.get();
        pointsDiv.textContent = String(pointsWallet?.balance || 0);
      }

      // Discount buttons
      const discountButtons = document.querySelectorAll(".discount-btn");
      discountButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const pointsProductId = button.dataset.pointsProductId;
          const title = button.dataset.title;
          const productUrl = button.dataset.productUrl;
          showConfirmationPopup(title, pointsProductId, button, productUrl);
        });
      });
    } catch (err) {
      // console.warn(
      //   "DEBUG: An error occurred while identifying the customer: " + err
      // );

      // If we can't identify the customer, we update both discount buttons and referral links
      // to show the login popup when clicked
      const discountButtons = document.querySelectorAll(".discount-btn");
      const userRefLinks = document.querySelectorAll(".user-ref-link");

      [...discountButtons, ...userRefLinks].forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          showLoginPopup();
        });
      });

      // Handle error state for points balance
      if (pointsDiv) {
        stopLoadingAnimation();
        pointsDiv.textContent = "--";
      }
    }
  }

  function showPopupError(popupElement, anchorElement, message) {
    // Remove any existing error message first
    const existing = popupElement.querySelector(".popup-error-message");
    if (existing) existing.remove();

    const errorEl = document.createElement("div");
    errorEl.className = "popup-error-message";
    errorEl.style.cssText =
      "color: #e53e3e; background: #fff5f5; border: 1px solid #fed7d7; border-radius: 6px; font-size: 13px; padding: 10px 14px; margin-top: 12px; text-align: center; line-height: 1.4;";
    errorEl.textContent = message;

    // Insert after the anchor element (the button)
    anchorElement.parentNode.insertBefore(errorEl, anchorElement.nextSibling);

    // Auto-remove after 6 seconds
    setTimeout(() => {
      if (errorEl.parentNode) errorEl.remove();
    }, 6000);
  }

  function showCopySuccessPopup() {
    const template = document.getElementById("copy-success-popup-template");
    if (!template) return;
    const popup = template.content.cloneNode(true);

    const overlay = popup.querySelector(".membership-overlay");
    const popupElement = popup.querySelector(".membership-popup");

    document.body.appendChild(popup);

    const closePopup = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popupElement);
    };

    overlay.addEventListener("click", closePopup);

    const closeBtn = popupElement.querySelector(".popup-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);
  }

  function showLoginPopup() {
    const template = document.getElementById("login-popup-template");
    if (!template) return;
    const popup = template.content.cloneNode(true);

    const overlay = popup.querySelector(".membership-overlay");
    const popupElement = popup.querySelector(".membership-popup");

    document.body.appendChild(popup);

    const closePopup = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popupElement);
    };

    overlay.addEventListener("click", closePopup);

    const closeBtn = popupElement.querySelector(".membership-popup-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);

    const loginBtn = popupElement.querySelector("#loginBtn");
    if (!loginBtn) return;
    loginBtn.addEventListener("click", () => {
      window.location.href = "/account/login?return_url=/pages/rewards";
    });
  }

  function showConfirmationPopup(title, pointsProductId, button, productUrl) {
    const template = document.getElementById("confirmation-popup-template");
    if (!template) return;
    const popup = template.content.cloneNode(true);

    // Create a copy of the clicked button
    const buttonCopy = button.cloneNode(true);
    buttonCopy.removeAttribute("id");
    buttonCopy.classList.remove("discount-btn");
    buttonCopy.classList.remove("content-block");
    buttonCopy.classList.add("discount-btn-display");

    // Remove any event listeners
    const newButtonCopy = buttonCopy.cloneNode(true);

    // Insert the button copy into the popup
    popup.querySelector(".discount-btn-copy").appendChild(newButtonCopy);

    const overlay = popup.querySelector(".membership-overlay");
    const popupElement = popup.querySelector(".membership-popup");

    // copy the text inside .discount-code-desc to .discount-btn-description
    const description = button.querySelector(".discount-code-desc");
    const descriptionCopy = description ? description.innerText : "";
    const descriptionTarget = popupElement.querySelector(
      ".discount-btn-description",
    );
    if (descriptionTarget) descriptionTarget.innerText = descriptionCopy;

    document.body.appendChild(popup);

    const closePopup = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popupElement);
    };

    overlay.addEventListener("click", closePopup);

    const closeBtn = popupElement.querySelector(".membership-popup-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);

    popupElement
      .querySelector("#confirmBtn")
      .addEventListener("click", async () => {
        const confirmBtn = popupElement.querySelector("#confirmBtn");

        // Show loading state
        const originalText = confirmBtn.textContent;
        confirmBtn.disabled = true;
        confirmBtn.textContent = "Processing…";

        try {
          // Resolve the Smile SDK (uses cached ref or waits for it)
          const smile = await getSmile();

          const normalizedPointsProductId = Number(pointsProductId);
          const purchaseArg = Number.isFinite(normalizedPointsProductId)
            ? normalizedPointsProductId
            : pointsProductId;

          const pointsPurchase =
            await smile.pointsProducts.purchase(purchaseArg);

          console.debug(
            "DEBUG: pointsProducts.purchase response:",
            pointsPurchase,
          );

          const code = extractRewardCode(pointsPurchase);
          const purchaseSucceeded = looksLikeSuccessfulPurchase(pointsPurchase);

          // Some rewards do not return a code, but redemption can still succeed.
          if (!code && !purchaseSucceeded) {
            throw new Error("Reward redemption failed. Please try again.");
          }

          const codeInput = popupElement.querySelector(
            ".copy-code-container input",
          );
          const copyContainer = popupElement.querySelector(
            ".copy-code-container",
          );
          const copyButton = popupElement.querySelector(
            ".copy-code-container .copy-button",
          );

          if (code) {
            // Copy to clipboard silently (best-effort)
            navigator.clipboard.writeText(code).catch(() => {});
          }

          if (codeInput && code) codeInput.value = code;
          if (copyButton && code) {
            copyButton.addEventListener("click", () => {
              navigator.clipboard
                .writeText(code)
                .then(() => {
                  const prevText = copyButton.textContent;
                  copyButton.textContent = "Copied!";
                  copyButton.disabled = true;
                  setTimeout(() => {
                    copyButton.textContent = prevText;
                    copyButton.disabled = false;
                  }, 2000);
                })
                .catch(() => {
                  copyButton.textContent = "Failed – try manually";
                  setTimeout(() => {
                    copyButton.textContent = "Copy";
                  }, 2000);
                });
            });
          }

          if (!code && copyContainer) {
            copyContainer.style.display = "none";
          }

          popupElement.classList.add("membership-popup--success");

          // If a product URL is configured, inject a dedicated "Shop Now" anchor
          // after the copy-code-container rather than repurposing the close button
          // (which has competing CSS display rules).
          if (productUrl) {
            const shopNowLink = document.createElement("a");
            shopNowLink.href = productUrl;
            shopNowLink.target = "_blank";
            shopNowLink.textContent = "Shop Now →";
            shopNowLink.className =
              "membership-banner-btn membership-banner-btn--black redeem-shop-now-btn";
            shopNowLink.style.cssText =
              "display: flex; margin: 16px auto 0; text-decoration: none;";
            const copyContainer = popupElement.querySelector(
              ".copy-code-container",
            );
            if (copyContainer && copyContainer.parentNode) {
              copyContainer.parentNode.insertBefore(
                shopNowLink,
                copyContainer.nextSibling,
              );
            } else {
              popupElement.appendChild(shopNowLink);
            }
          }
        } catch (err) {
          console.error("Redeem error:", err);

          // Determine a friendly message
          let friendlyMessage = "Something went wrong. Please try again.";
          const status = getErrorStatus(err);
          const msg = (err.message || "").toLowerCase();

          if (status === 401 || status === 403) {
            friendlyMessage = "Your session expired. Please log in again.";
          } else if (status === 0) {
            friendlyMessage =
              "Network error. Please check your connection and try again.";
          } else if (status === 404) {
            friendlyMessage =
              "This reward is no longer available. Please refresh and try another reward.";
          } else if (status === 429) {
            friendlyMessage =
              "Too many requests. Please wait a moment and try again.";
          } else if (status && status >= 500) {
            friendlyMessage =
              "The rewards service is temporarily unavailable. Please try again later.";
          } else if (
            status === 400 &&
            (msg.includes("point") ||
              msg.includes("insufficient") ||
              msg.includes("balance") ||
              msg.includes("not enough"))
          ) {
            friendlyMessage =
              "You don't have enough points to redeem this reward.";
          } else if (
            msg.includes("insufficient") ||
            msg.includes("insufficient points") ||
            msg.includes("balance") ||
            msg.includes("not enough")
          ) {
            friendlyMessage =
              "You don't have enough points to redeem this reward.";
          } else if (msg.includes("unavailable") || msg.includes("service")) {
            friendlyMessage =
              "The rewards service is temporarily unavailable. Please try again later.";
          } else if (err.message) {
            friendlyMessage = err.message;
          }

          if (err && err.requestId) {
            console.error("Smile requestId:", err.requestId);
          }

          showPopupError(popupElement, confirmBtn, friendlyMessage);

          // Restore button
          confirmBtn.disabled = false;
          confirmBtn.textContent = originalText;
        }
      });
  }

  // Retry wrapper for fetchPointsProducts
  async function fetchPointsProductsWithRetry(maxRetries = 2) {
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        await fetchPointsProducts();
        return; // success
      } catch (err) {
        console.error(
          `DEBUG: fetchPointsProducts failed (attempt ${attempt + 1}/${maxRetries + 1}):`,
          err,
        );
        if (attempt < maxRetries) {
          // Wait before retrying (exponential backoff: 2s, 4s)
          await new Promise((resolve) =>
            setTimeout(resolve, 2000 * (attempt + 1)),
          );
        }
      }
    }
    // All retries exhausted — show fallback UI
    console.error("DEBUG: fetchPointsProducts failed after all retries");
    document.querySelectorAll(".skeleton-card").forEach((el) => el.remove());
    if (pointsDiv) {
      stopLoadingAnimation();
      pointsDiv.textContent = "--";
    }
  }

  fetchPointsProductsWithRetry();
});
